import React from "react";
import { Typography } from "antd";
const { Text } = Typography;
const Currency = (props) => {
  const { text, maximumFractionDigits, alert } = props;
  return (
    <Text style={{ color: alert ? "red" : "inherit" }}>
      {new Intl.NumberFormat("he", {
        style: "currency",
        currency: "ILS",
        maximumFractionDigits: maximumFractionDigits
          ? maximumFractionDigits
          : 2,
      }).format(text)}
    </Text>
  );
};

export default Currency;
